import {
	churchOfPseudoscience,
	factoryReduction,
	mulligan,
	recyclingPlant,
	tieBreaker,
} from '@lc/const/modifiers';
import { normalSeasonalTurn } from '@lc/const/turnTypes';
import { controller_card } from '@lc/controller/card';
import { GameState } from '@lc/interface/gameState/types';
import { act_payment } from '@lc/interface/payment/action';
import { act_player } from '@lc/interface/player/action';
import { Player } from '@lc/interface/player/types';
import { getRandomArrayIndex } from '@lc/lib/array';
import { getCurrentSeasonDeck } from '@lc/lib/gamestate_helper';
import {
	getPlayerArrayIndex,
	getPlayerStateWithId,
} from '@lc/lib/player_helper';
import { getNextActivePlayer } from '@lc/lib/timeline/modifier';
import { energyColors } from '@lc/types/Misc';

export class CommonAction {
	createNeighborIdArray(playerData: any, players: any) {
		const { playerId } = playerData;

		const playerIndex = getPlayerArrayIndex(players, playerId);

		let leftPlayer = 0;
		let rightPlayer = players.length - 1;

		if (playerIndex === 0) {
			rightPlayer = players.length - 1;
			leftPlayer = 1;
		} else if (playerIndex === players.length - 1) {
			leftPlayer = players.length - 2;
			rightPlayer = 0;
		} else {
			leftPlayer = playerIndex - 1;
			rightPlayer = playerIndex + 1;
		}

		console.log('NEIGHBOR INDEX CHECK!');
		console.log('PlayerIndex: ' + playerIndex);
		console.log('leftPlayer: ' + leftPlayer);
		console.log('rightPlayer: ' + rightPlayer);

		return [leftPlayer, playerIndex, rightPlayer];
	}

	createNeighborIdArrayVerbose(playerData: any, players: any) {
		const neighborIdArrTmp = this.createNeighborIdArray(
			playerData,
			players
		);

		const leftPlayer = players[neighborIdArrTmp[0]];
		const rightPlayer = players[neighborIdArrTmp[2]];

		return [
			{
				player_id: leftPlayer.playerId,
				color: leftPlayer.color,
			},
			{
				player_id: rightPlayer.playerId,
				color: rightPlayer.color,
			},
		];
	}

	createAwardTargetArrayVerbose(playerData: any, players: any) {
		const { winnerId } = playerData;
		const neighborIdArrVerbose: any[] = [];

		const neighborIdArr = this.createNeighborIdArray(playerData, players);

		for (let i = 0; i < neighborIdArr.length; i++) {
			const nId = neighborIdArr[i];
			if (nId === winnerId) continue;

			const currN = players[nId];

			neighborIdArrVerbose.push({
				player_id: currN.playerId,
				color: currN.color,
			});
		}

		return neighborIdArrVerbose;
	}

	getNeighborPlayerIds(playerId: number, players: Player[]) {
		const sorted = [...players].sort((a, b) => a.playerId - b.playerId);

		const index = sorted.findIndex((p) => p.playerId === playerId);
		if (index === -1) return [];

		const left = (index - 1 + sorted.length) % sorted.length;
		const right = (index + 1) % sorted.length;

		return [left, right];
	}
	// TODO for contracts and awards. Upon timeline, we will check all triggers on all players in player turn order
	// trigger will check current state, then run effect from master table if attached
	// runs at advanceTimeline

	// contracts will run function then apply trigger
	// awards will just apply trigger

	// trigger = {
	//     triggerName: string,
	//     season = // season, due date, something that we can relate "when" the trigger launches
	// }

	// I don't actually need triggers, I will have array of contracts played in due date order. Just iterate through my contract
	// then my award list, or just have an "active contracts and awards" array
	/*
	applyTrigger(playerData: any, gameState: GameState, trigger: any) {
		const { playerId } = playerData;
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);
		// pState.triggers.push(trigger);
	}
	*/

	buyPr(playerData: any, gameState: GameState) {
		// TODO replace with numPR in playerData (replace playerID)
		const { playerId, paymentObject } = playerData;
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);

		const prColors: energyColors[] = [];

		for (let i = 0; i < paymentObject.factoryEnergyArr.length; i++) {
			prColors.push(paymentObject.factoryEnergyArr[i]);
		}
		for (let i = 0; i < paymentObject.batteryEnergyArr.length; i++) {
			prColors.push(paymentObject.batteryEnergyArr[i]);
		}
		for (let i = 0; i < paymentObject.carbonReserve; i++) {
			prColors.push(pState.energyColor);
		}

		if (prColors.length <= 0) {
			return false;
		}

		act_player.buyPR(pState, prColors);

		return true;
	}

	buyPrCard(playerData: any, gameState: GameState, cost: number) {
		// TODO replace with numPR in playerData (replace playerID)
		const { playerId, paymentObject } = playerData;
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);

		const total = act_payment.getPaymentObjectTotal(paymentObject);

		if (total !== cost) {
			return false;
		}

		const prColors: energyColors[] = [];

		for (let i = 0; i < paymentObject.factoryEnergyArr.length; i++) {
			prColors.push(paymentObject.factoryEnergyArr[i]);
		}
		for (let i = 0; i < paymentObject.batteryEnergyArr.length; i++) {
			prColors.push(paymentObject.batteryEnergyArr[i]);
		}
		for (let i = 0; i < paymentObject.carbonReserve; i++) {
			prColors.push(pState.energyColor);
		}

		if (prColors.length <= 0) {
			return false;
		}

		act_player.buyPR(pState, prColors);

		return true;
	}

	drawCards(playerData: any, gameState: GameState, numCards: number) {
		const { playerId } = playerData;
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);

		let deck: number[] = [];

		if (gameState.seasonTracker < 2) {
			deck = gameState.DeckSS;
		} else {
			deck = gameState.DeckFW;
		}

		if (deck.length === 0) return false;

		let i = numCards;
		while (i > 0) {
			if (deck.length > 0) {
				pState.seasonalCards.push(deck.shift() as any);
				i--;
			} else break;
		}

		return true;
	}

	gainBattery(playerData: any, gameState: GameState) {
		const { playerId } = playerData;
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);
		if (pState.batteries < 6) {
			act_player.buyBattery(pState);
			return true;
		}
		return false;
	}

	gainBatteryPrecharged(playerData: any, gameState: GameState) {
		return (
			this.gainBattery(playerData, gameState) &&
			this.rechargeBattery(playerData, gameState)
		);
	}

	gainCarbon(playerData: any, gameState: GameState, numCarbon = 1) {
		const { playerId } = playerData;
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);

		if (gameState.carbonReservoir > 0) {
			let removedCarbon = 0;
			if (gameState.carbonReservoir - numCarbon > 0) {
				removedCarbon = numCarbon;
				gameState.carbonReservoir -= numCarbon;
			} else {
				removedCarbon = gameState.carbonReservoir;
				gameState.carbonReservoir = 0;
			}
			pState.carbonReserve += removedCarbon;
		}

		return false;
	}

	gainFactory(playerData: any, gameState: GameState) {
		const { playerId } = playerData;
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);
		if (pState.factories < 6) {
			pState.factories++;
			return true;
		}
		return false;
	}

	giveBatteryToTarget(pState: any, tState: any) {
		act_player.buyBattery(tState);

		if (pState.batteries === pState.batteryEnergyArr.length) {
			tState.batteryEnergyArr.push(pState.batteryEnergyArr[0]);
		}

		act_player.deleteBattery(pState);
	}

	giveFactoryToTarget(pState: any, tState: any) {
		tState.factories += 1;

		if (pState.factories === pState.factoryEnergyArr.length) {
			tState.factoryEnergyArr.push(pState.factoryEnergyArr[0]);
		}

		act_player.deleteFactory(pState);
	}

	getPlayerNumActiveContracts(tState: any) {
		let numActiveContracts = 0;
		for (let i = 0; i < tState.activeContractsAndAwards.length; i++) {
			const currCard = controller_card.getCurrCard(
				tState.activeContractsAndAwards[i]
			);
			if (currCard != null && currCard.type === 'Contract') {
				numActiveContracts++;
			}
		}

		return numActiveContracts;
	}

	giveFootprint(playerData: any, gameState: GameState) {
		const { playerId, targetId } = playerData;
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);
		const tState = getPlayerStateWithId(
			gameState.playerStateArray,
			targetId
		);

		const pFootprint = pState.carbonFootprint;
		pState.carbonFootprint = 0;
		tState.carbonFootprint += pFootprint;

		return true;
	}

	// TODO broken for now, source Id doesn't exist
	moveCarbonForPR(playerData: any, gameState: GameState) {
		// if i have 1 Pr and sourcePlayerId has 1 carbon reserve in reserve move into targetPlayerId carbon footprint
		const { playerId, sourceId, targetId } = playerData;
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);
		const sState = getPlayerStateWithId(
			gameState.playerStateArray,
			sourceId
		);
		const tState = getPlayerStateWithId(
			gameState.playerStateArray,
			targetId
		);

		if (pState.prArr.length > 0 && sState.carbonReserve > 0) {
			pState.prArr.pop();
			sState.carbonReserve--;
			tState.carbonFootprint++;
			return true;
		}
		return false;
	}

	mulligan(playerData: any, gameState: GameState) {
		const {
			playerId,
			// sourceId,
			// targetId
		} = playerData;
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);

		if (pState.summitCards.length < 2 && gameState.DeckSummit.length > 0) {
			return false;
		}

		const i = getRandomArrayIndex(pState.summitCards);
		pState.summitCards.splice(i, 1);

		const j = getRandomArrayIndex(pState.summitCards);
		pState.summitCards.splice(j, 1);

		const summitCardId = gameState.DeckSummit.shift();

		if (
			summitCardId !== undefined &&
			summitCardId !== null &&
			summitCardId >= 0
		) {
			pState.summitCards.push(summitCardId);

			pState.modifiers.push(mulligan);
			return true;
		}

		return false;
	}

	neighborsGetBatteries(playerData: any, gameState: GameState) {
		const players = gameState.playerStateArray;

		const neighborIds = this.createNeighborIdArray(
			playerData,
			players
		) as any;
		act_player.buyBattery(neighborIds[0]);
		act_player.buyBattery(neighborIds[2]);

		return true;
	}

	notPlayable(_playerData: any, _gameState: GameState) {
		return false;
	}

	notPlayableWinterSummit(_playerData: any, _gameState: GameState) {
		return true;
	}

	// Basic choice to determine new turn order. 0 is first, 1 is last
	prTurnOrderDecision(playerData: any, gameState: GameState) {
		const { playerId, choiceInt } = playerData;

		const turnOrderTemp = [
			...gameState.initPlayerTableOrder,
			...gameState.initPlayerTableOrder,
		];

		const turnOrderFinal: number[] = [];
		let numPlayerTemp = 0;
		let index = 0;
		let playerFound = false;

		if (choiceInt === 0) {
			// last
			while (numPlayerTemp < gameState.numPlayers) {
				if (playerFound) {
					turnOrderFinal.push(turnOrderTemp[index]);
					index++;
					numPlayerTemp++;
				} else {
					if (turnOrderTemp[index] === playerId) {
						playerFound = true;
						turnOrderFinal.push(turnOrderTemp[index]);
						index++;
						numPlayerTemp++;
					}
				}
			}
		} else if (choiceInt === 1) {
			while (numPlayerTemp < gameState.numPlayers) {
				if (playerFound) {
					turnOrderFinal.push(turnOrderTemp[index]);
					index++;
					numPlayerTemp++;
				} else {
					if (turnOrderTemp[index] === playerId) {
						numPlayerTemp++;
					}
				}
			}
		}

		gameState.turnOrder = turnOrderFinal;
		gameState.currentTurnTypePlayerTableOrder = turnOrderFinal;

		return false;
	}

	pseudoscience(playerData: any, gameState: GameState) {
		const { playerId } = playerData;
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);

		// TAKE LAST PR FROM PRARR, MOVE TO BATTERY ARRAY IF SPACE
		if (
			pState.prArr.length <= 0 &&
			pState.batteries <= pState.batteryEnergyArr.length
		) {
			return false;
		}

		const lastPR = pState.prArr.pop() || pState.energyColor;
		pState.batteryEnergyArr.push(lastPR);

		pState.modifiers.push(churchOfPseudoscience);

		return true;
	}

	rechargeBattery(playerData: any, gameState: GameState) {
		const { playerId } = playerData;

		return this.rechargeBatteryForPlayerId(playerId, gameState);
	}

	rechargeBatteryForPlayerId(playerId: number, gameState: GameState) {
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);
		const energyColor = pState.energyColor;

		if (pState.batteries > pState.batteryEnergyArr.length) {
			pState.batteryEnergyArr.push(energyColor);
			return true;
		}
		return false;
	}

	rechargeBatteryWithEnergyColorForPlayerId(
		playerId: number,
		gameState: GameState,
		energyColor: energyColors
	) {
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);

		if (pState.batteries > pState.batteryEnergyArr.length) {
			pState.batteryEnergyArr.push(energyColor);
			return true;
		}
		return false;
	}

	rechargeAllBatteries(playerData: any, gameState: GameState) {
		const { playerId } = playerData;
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);

		if (pState.batteries === pState.batteryEnergyArr.length) {
			return false;
		}

		while (pState.batteries > pState.batteryEnergyArr.length) {
			pState.batteryEnergyArr.push(pState.energyColor);
			// TODO good video idea here, what's wrong with the code?
			// Code Corrections
			// return true;
		}
		return true;
	}

	rechargeAndGainBatteries(playerData: any, gameState: GameState) {
		this.rechargeAllBatteries(playerData, gameState);
		this.gainBattery(playerData, gameState);

		return true;
	}

	recyclingPlant(playerData: any, gameState: GameState) {
		const { playerId, discardCardId } = playerData;
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);

		const currDeck = getCurrentSeasonDeck(gameState) as any;

		if (currDeck.length === 0) {
			return false;
		}

		pState.seasonalCards.splice(
			pState.seasonalCards.indexOf(discardCardId),
			1
		);
		gameState.discardPile.push(discardCardId);
		pState.seasonalCards.push(currDeck.shift());
		pState.modifiers.push(recyclingPlant);

		return true;
	}

	reduceFactoryCost(playerData: any, gameState: GameState) {
		const { playerId } = playerData;
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);
		pState.modifiers.push(factoryReduction);
	}

	reduceTargetPR(playerData: any, gameState: GameState) {
		const { targetId } = playerData;
		const tState = getPlayerStateWithId(
			gameState.playerStateArray,
			targetId
		);

		if (tState.prArr.length > 0) {
			tState.prArr.pop();

			return true;
		}

		return false;
	}

	selfImageSacrifice(playerData: any, gameState: GameState) {
		const { playerId } = playerData;
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);

		// TAKE LAST PR FROM PRARR, MOVE TO DONATION CUP
		if (pState.prArr.length <= 0) {
			return false;
		}

		const lastPR = pState.prArr.pop() || pState.energyColor;
		pState.donationCupArr.push(lastPR);

		return true;
	}

	stealCardForEnergy(playerData: any, gameState: GameState) {
		const { playerId, targetId, cardId } = playerData;
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);
		const tState = getPlayerStateWithId(
			gameState.playerStateArray,
			targetId
		);

		// if target has energy on factory OR battery
		// player has empty battery slot
		// AND player has at least 1 card
		// TODO player chooses what energy to steal

		let stolenEnergy: any;
		if (pState.seasonalCards.length <= 1) {
			return false;
		}
		if (pState.batteries <= pState.batteryEnergyArr.length) {
			return false;
		}
		if (
			tState.factoryEnergyArr.length === 0 &&
			tState.batteryEnergyArr.length === 0
		) {
			return false;
		}

		if (tState.factoryEnergyArr.length > 0) {
			stolenEnergy = tState.factoryEnergyArr.pop();
		}

		if (!stolenEnergy) {
			stolenEnergy = tState.batteryEnergyArr.pop();
		}

		pState.batteryEnergyArr.push(stolenEnergy);

		const currCardId = pState.seasonalCards.indexOf(cardId); // card is removed after action, so must be removed from cards that can be stolen
		pState.seasonalCards.splice(currCardId, 1);

		const stolenCardIndex = getRandomArrayIndex(pState.seasonalCards);
		const stolenCard = pState.seasonalCards.splice(stolenCardIndex, 1);

		tState.seasonalCards.push(stolenCard[0]);
		pState.seasonalCards.push(currCardId);
		return true;
	}

	stealDonation(playerData: any, gameState: GameState) {
		const { playerId, targetId } = playerData;
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);
		const tState = getPlayerStateWithId(
			gameState.playerStateArray,
			targetId
		);

		let stolenEnergy: any;

		if (
			tState.factoryEnergyArr.length === 0 &&
			tState.batteryEnergyArr.length === 0
		) {
			return false;
		}

		if (tState.factoryEnergyArr.length > 0) {
			stolenEnergy = tState.factoryEnergyArr.pop();
		}

		if (!stolenEnergy) {
			stolenEnergy = tState.batteryEnergyArr.pop();
		}

		pState.donationCupArr.push(stolenEnergy);

		return true;
	}

	stealEnergy(playerData: any, gameState: GameState) {
		const { playerId, targetId } = playerData;
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);
		const tState = getPlayerStateWithId(
			gameState.playerStateArray,
			targetId
		);

		let stolenEnergy: any;
		if (pState.batteries <= pState.batteryEnergyArr.length) {
			return false;
		}

		if (
			tState.factoryEnergyArr.length === 0 &&
			tState.batteryEnergyArr.length === 0
		) {
			return false;
		}

		if (tState.factoryEnergyArr.length > 0) {
			stolenEnergy = tState.factoryEnergyArr.pop();
		}

		if (!stolenEnergy) {
			stolenEnergy = tState.batteryEnergyArr.pop();
		}

		pState.batteryEnergyArr.push(stolenEnergy);

		return true;
	}

	swapFootprints(playerData: any, gameState: GameState) {
		const { playerId } = playerData;
		const players = gameState.playerStateArray;
		const pState = getPlayerStateWithId(players, playerId);
		let tState = players[0];

		for (let i = 0; i < players.length; i++) {
			if (i === playerId) continue;
			if (tState.carbonFootprint < players[i].carbonFootprint) {
				tState = players[i];
			}
		}

		if (tState?.carbonFootprint > pState.carbonFootprint) {
			const tempPrint = tState.carbonFootprint;
			tState.carbonFootprint = pState.carbonFootprint;
			pState.carbonFootprint = tempPrint;
		}

		return true;
	}

	terminateBattery(playerData: any, gameState: GameState) {
		const {
			// playerId,
			targetId,
		} = playerData;
		const tState = getPlayerStateWithId(
			gameState.playerStateArray,
			targetId
		);

		if (tState.batteries === 0) {
			return false;
		}

		tState.batteries -= 1;
		if (tState.batteryEnergyArr.length > tState.batteries) {
			tState.batteryEnergyArr.pop();
		}
		return true;
	}

	tieBreakerAddModifier(playerData: any, gameState: GameState) {
		const { playerId } = playerData;
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);

		pState.modifiers.push(tieBreaker);

		return true;
	}

	async updateTurnOrderDecision(playerData: any, gameState: GameState) {
		const {
			// playerId,
			// gameId,
			targetId,
		} = playerData;
		// 1st player is chosen given all player Id's (via color in dropdown)
		// send playerId via chosen drop down, functionality should be visible in decision modal
		// take player with id, which is same as init table order for game, that's our starting player

		const newTurnOrderHelper = [
			...gameState.initPlayerTableOrder,
			...gameState.initPlayerTableOrder,
		];

		console.log('newTurnOrderHelper');
		console.log(newTurnOrderHelper);

		const newTurnOrder = newTurnOrderHelper.splice(
			targetId,
			gameState.numPlayers
		);

		console.log('newTurnOrder');
		console.log(newTurnOrder);

		gameState.currentTurnTypePlayerTableOrder = [...newTurnOrder];
		gameState.turnOrder = [...newTurnOrder];
		gameState.turnType = normalSeasonalTurn;
		await getNextActivePlayer(gameState);
	}
}

export const act_com = new CommonAction();
